<template>
<div style="padding-top: 15px;">
  <div class="col-sm-12 form-group">
    <div class="pull-right">
      <el-button type="primary"
        @click="publishEvent"
      >Publish Changes</el-button>
    </div>
  </div>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom:60px;margin:0 !important;">
              <div class="col-xs-12 form-group" style="padding-top: 30px;display: inline-block;">
              <h3 class="Bold">Pending for Publish: </h3>
              </div>

              <!-- <div class="form-horizontal">
                <div class="form-group  margin-0">
                  <label class="col-sm-2 control-label">
                    Status
                  </label>
                  <div class="col-sm-4">
                    <div>
                      <el-select v-model="status" clearable  >
                          <el-option 
                          v-for="item in statusObj"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                          </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class>
                      <el-button type="primary" @click="search">{{
                        $t("message.Search")
                      }}</el-button>
                    </div>
                  </div>
                </div>
              </div> -->

                {{total}}{{ $t("message.datagridresult") }}
              <el-table
                :data="rows"
                border
                style="width: 100%"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                row-key="id"
              >
                <el-table-column
                  prop="systemType"
                  :show-overflow-tooltip="true"
                  label="Function"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  prop="systemName"
                  :show-overflow-tooltip="true"
                  label="Name"
                  width="150"
                ></el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="statusName"
                  label="Status"
                  width="150"
                ></el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="createdAt"
                  label="Created At"
                  width="150"
                ></el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="createdBy"
                  label="Created By"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="updatedAt"
                  label="Updated At"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="updatedBy"
                  label="Updated By"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  width="250"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <StatusBtn 
                      :id="scope.row.systemId" 
                      :status="scope.row.systemStatus"
                      :init="init"
                      :type="scope.row.systemType"
                      :approval="''"
                    ></StatusBtn>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination 
                   layout="total, sizes, prev, pager, next, jumper" 
                   @size-change="handleSizeChange" 
                   @current-change="handleCurrentChange" 
                   :page-sizes="[10, 20, 50, 100]" 
                   :page-size="pagesize" 
                   :total="total" 
                   style="float:right;">
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom:60px;margin:0 !important;">
              <div class="col-xs-12 form-group" style="padding-top: 30px;display: inline-block;">
              <h3 class="Bold">Suspend Data (not show on app): </h3>
              <p>The “Reject” status item will NOT display in this page. For check or update the status of the “Rejected” item, please go to the section detail page.</p>
                {{totalTwo}}{{ $t("message.datagridresult") }}
              </div>
              <el-table
                :data="rowsTwo"
                border
                style="width: 100%"
                ref="multipleTable"
                @selection-change="handleSelectionChangeTwo"
                row-key="id"
              >
                <el-table-column
                  prop="systemType"
                  :show-overflow-tooltip="true"
                  label="Function"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  prop="systemName"
                  :show-overflow-tooltip="true"
                  label="Name"
                  width="150"
                ></el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="statusName"
                  label="Status"
                  width="150"
                ></el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="createdAt"
                  label="Created At"
                  width="150"
                ></el-table-column>
                <el-table-column
                  :show-overflow-tooltip="true"
                  prop="createdBy"
                  label="Created By"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="updatedAt"
                  label="Updated At"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="updatedBy"
                  label="Updated By"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  width="250"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <StatusBtn 
                      :id="scope.row.systemId" 
                      :status="scope.row.systemStatus"
                      :init="init"
                      :type="scope.row.systemType"
                      :approval="''"
                    ></StatusBtn>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination 
                   layout="total, sizes, prev, pager, next, jumper" 
                   @size-change="handleSizeChangeTwo" 
                   @current-change="handleCurrentChangeTwo" 
                   :page-sizes="[10, 20, 50, 100]" 
                   :page-size="pagesizeTwo" 
                   :total="totalTwo" 
                   style="float:right;">
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import draggable from 'vuedraggable'

import StatusBtn from "../components/common/statusBtn.vue"
export default {
  mixins: [config.globalMixin],
  data() {
    return {
      page: 0,//当前页数
      pagesize:10,//一页显示几条
      total:0,
      pageTwo: 0,//当前页数
      pagesizeTwo:10,//一页显示几条
      totalTwo:0,
      rows:[],
      rowsTwo:[],
      startDate:"",
      endDate:"",
      ocTable:"",
      ocAction:"",
      multipleSelection:[],
      sortType:"DESC",
      sortField:"id",
      showDetail:false,
      compareDetail:[],
      lastPublishDate:"",
      lastPublisher:"",
      statusObj:[],
      status:"",
    };
  },
  created() {

      this.statusObj = [
        {
          value: "0",
          label: "Pending"
        },
        {
          value: "1",
          label: "Pending approval"
        },
        {
          value: "2",
          label: "Approved"
        },
        {
          value: "3",
          label: "Reject"
        },
        {
          value: "4",
          label: "Suspend"
        },
      ];
  },
  components: {
    draggable,
    StatusBtn
  }, 
  methods: {
    async publishEvent(){
      var objdata = this.getAuthObj();
      objdata.apiUrl = this.apiConfig.systemApprovePublish;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$message({
        message: 'Publish Success',
        type: 'success'
      });
      this.page = 0;
      this.init()
      this.pageTwo = 0;
    },
    handleSizeChangeTwo:function(val){
      this.pagesizeTwo = val;
      this.initTwo();
    },
    handleCurrentChangeTwo:function(val){
      this.pageTwo = val-1;
      this.initTwo();
    },
    handleSelectionChangeTwo:function(val){
      this.multipleSelection = val;
    },
    search(){
      this.page = 0;
      this.init();
    },
    async init() {
      var objdata = this.getAuthObj();
      objdata.pageIndex = this.pageTwo;
      objdata.pageSize = this.pagesizeTwo;

      objdata.sortName = this.sortField;
      objdata.sortType = this.sortType;
      objdata.systemStatus = "1,2";
      objdata.apiUrl = this.apiConfig.systemApproveList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.rows = data.data.result.systemLogs;
      this.total = data.data.result.total;
      let list = null;
      for (list of this.rows) {
        list.createdAt = this.dateFormat(list.createdAt);
        list.updatedAt = this.dateFormat(list.updatedAt);
        if (list.systemStatus === 0) {
          list.statusName = "Draft";
        } else if (list.systemStatus == 1) {
          list.statusName = "Pending approval";
        } else if (list.systemStatus == 2) {
          list.statusName = "Pending Publish";
        } else if (list.systemStatus == 3) {
          list.statusName = "Rejected";
        } else if (list.systemStatus == 4) {
          list.statusName = "Suspended";
        } else if (list.systemStatus == 5) {
          list.statusName = "Pending Suspend";
        } else if (list.systemStatus == 6) {
          list.statusName = "Published";
        }
      }
      this.initTwo()
    },
    async initTwo() {
      var objdata = this.getAuthObj();
      objdata.pageIndex = this.pageTwo;
      objdata.pageSize = this.pagesizeTwo;

      objdata.sortName = this.sortField;
      objdata.sortType = this.sortType;
      objdata.systemStatus = "4,5";
      objdata.apiUrl = this.apiConfig.systemApproveList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(data == "000104"){
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.rowsTwo = data.data.result.systemLogs;
      this.totalTwo = data.data.result.total;
      let list = null;
      for (list of this.rowsTwo) {
        list.createdAt = this.dateFormat(list.createdAt);
        list.updatedAt = this.dateFormat(list.updatedAt);
        if (list.systemStatus === 0) {
          list.statusName = "Draft";
        } else if (list.systemStatus == 1) {
          list.statusName = "Pending approval";
        } else if (list.systemStatus == 2) {
          list.statusName = "Pending Publish";
        } else if (list.systemStatus == 3) {
          list.statusName = "Rejected";
        } else if (list.systemStatus == 4) {
          list.statusName = "Suspended";
        } else if (list.systemStatus == 5) {
          list.statusName = "Pending Suspend";
        } else if (list.systemStatus == 6) {
          list.statusName = "Published";
        }
      }
    },
  },
  mounted() {
    this.init();
  }
};
</script>
